import { MChatRiscoEnum } from 'graphql/types.generated'
import HistoricoDetailTable from 'view/atendimentos/detail/historico/components/table/HistoricoDetailTable'
import {
  MCHAT_RESULTADOS,
  MCHAT_RF_RESULTADO_BY_STATUS,
} from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatResultado } from './HistoricoMChatResultado'

interface HistoricoMChatRfTableBoxProps {
  risco: MChatRiscoEnum | null
  pontuacao: number
}

export function HistoricoMChatRfTableBox(props: Readonly<HistoricoMChatRfTableBoxProps>) {
  const { risco, pontuacao } = props

  if (risco === null) return null

  const { title, encaminhamento, status } = MCHAT_RESULTADOS[risco]
  const { colorScale } = MCHAT_RF_RESULTADO_BY_STATUS[status]

  return (
    <HistoricoDetailTable title='Entrevista de seguimento'>
      <HistoricoMChatResultado
        title={title}
        titleColor={colorScale.c40}
        encaminhamento={encaminhamento()}
        label={'Falhou em ' + 'pergunta'.pluralizeAndConcatValue(pontuacao)}
      />
    </HistoricoDetailTable>
  )
}
